// removed by extract-text-webpack-plugin
module.exports = {"lista":"_1Lq2b","li":"CURuQ","objli":"_1WDEb CURuQ","lista-centrerad":"_1_2m3 _1Lq2b","ul":"sRehH"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Lista/Lista.scss
 ** module id = 171
 ** module chunks = 0
 **/